import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
export function StickyButton() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      // Show button after scrolling down 500px
      if (window.scrollY > 500) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <AnimatePresence data-id="element-183">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 100
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: 100
    }} className="fixed bottom-0 left-0 w-full z-40 md:hidden p-4 bg-gradient-to-t from-navy via-navy to-transparent pb-6" data-id="element-184">
          <a href="#pricing" onClick={e => {
        e.preventDefault();
        document.getElementById('pricing')?.scrollIntoView({
          behavior: 'smooth'
        });
      }} className="flex items-center justify-center w-full py-4 text-lg font-bold text-navy bg-gold rounded-lg shadow-[0_0_20px_rgba(201,168,76,0.3)] active:scale-95 transition-transform" data-id="element-185">
            👉 Acceder al Sistema PRO
          </a>
        </motion.div>}
    </AnimatePresence>;
}